import styled, { css } from 'styled-components';
var headerHeight = '65px';
export var Wrapper = styled.div.withConfig({
  displayName: "Drawerstyles__Wrapper",
  componentId: "sc-7kh0ae-0"
})(["", ""], function (props) {
  return props.isStatic && css(["@media (-ms-high-contrast:active),(-ms-high-contrast:none){height:100%;}"]);
});
export var Container = styled.div.withConfig({
  displayName: "Drawerstyles__Container",
  componentId: "sc-7kh0ae-1"
})(["z-index:90;display:flex;position:fixed;overflow-y:hidden;flex-direction:column;min-width:280px;max-width:500px;max-height:100%;width:90%;top:0;align-content:stretch;-webkit-overflow-scrolling:touch;box-shadow:0 0 10px rgba(0,0,0,0.6);", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (props) {
  return css(["background-color:", ";font-size:", ";"], props.theme.color.monochrome.white, props.theme.font.size.base);
}, function (props) {
  return props.position === 'right' && css(["left:auto;right:-1000px;will-change:right;", ""], props.show && css(["right:0;"]));
}, function (props) {
  return props.position === 'left' && css(["right:auto;left:-520px;will-change:left;", ""], props.show && css(["left:0;"]));
}, function (props) {
  return props.position === 'center' && css(["visibility:hidden;opacity:0;position:fixed;top:50%;left:50%;max-width:550px;max-height:", ";height:", ";@media (-ms-high-contrast:active),(-ms-high-contrast:none){height:", ";}transform:translate(-50%,-50%);will-change:opacity,visibility;", " ", ""], props.height === 'auto' ? '90%' : '650px', props.height === 'auto' ? 'auto' : '90%', props.height === 'auto' ? 'auto' : '90%', props.mobileFullScreen && css(["@media screen and (max-width:", "){top:0;left:0;width:100%;max-width:100%;max-height:100%;height:100%;transform:none;}"], props.theme.size.breakpoint['max-width'].xs), props.show && css(["visibility:visible;opacity:1;"]));
}, function (props) {
  return props.size === 'sm' && css(["max-width:280px;"]);
}, function (props) {
  return props.size === 'md' && css(["max-width:500px;"]);
}, function (props) {
  return props.size === 'lg' && css(["max-width:900px;"]);
}, function (props) {
  return props.size === 'full' && css(["width:100%;"]);
}, function (props) {
  return props.isStatic && css(["z-index:0;width:calc(25% - 30px);box-shadow:none;position:relative;border-radius:3px;border:", ";overflow:auto;@media screen and (max-width:", "){min-width:230px;}"], props.hasBorder ? "1px solid ".concat(props.theme.color.monochrome.base) : 'none', props.theme.size.breakpoint['max-width'].lg);
}, function (props) {
  return props.show && css(["pointer-events:auto;"]);
}, function (props) {
  return props.height === 'viewheight' && css(["height:100%;"]);
});
export var Header = styled.header.withConfig({
  displayName: "Drawerstyles__Header",
  componentId: "sc-7kh0ae-2"
})(["position:relative;min-height:", ";border-bottom:1px solid ", ";width:100%;display:flex;h4{align-items:center;display:flex;margin:0;padding-bottom:2px;width:calc(100% - 55px);}", ""], headerHeight, function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.isStatic || !props.hasBackButton ? css(["padding-left:15px;"]) : null;
});
export var CloseButton = styled.button.withConfig({
  displayName: "Drawerstyles__CloseButton",
  componentId: "sc-7kh0ae-3"
})(["height:", ";position:absolute;right:0;top:0;background:transparent;line-height:1;padding:0 15px;border:0;z-index:1;font-size:15px;cursor:pointer;", ""], headerHeight, function (props) {
  return props.isStatic && css(["display:none;"]);
});
export var BackButton = styled.button.withConfig({
  displayName: "Drawerstyles__BackButton",
  componentId: "sc-7kh0ae-4"
})(["height:", ";background:transparent;line-height:1;padding:0 15px;border:0;z-index:1;font-size:15px;cursor:pointer;", ""], headerHeight, function (props) {
  return props.isStatic && css(["display:none;"]);
});
export var Content = styled.div.withConfig({
  displayName: "Drawerstyles__Content",
  componentId: "sc-7kh0ae-5"
})(["flex:1 1 auto;position:relative;padding:15px;overflow-y:auto;", " ", " ", " ", " ", ""], function (props) {
  return props.smoothScrolling && css(["@media screen and (prefers-reduced-motion:no-preference){scroll-behavior:smooth;}"]);
}, function (props) {
  return props.isStatic && css(["height:initial;@media (-ms-high-contrast:active),(-ms-high-contrast:none){height:100%;overflow:auto;}"]);
}, function (props) {
  return !props.padding && css(["padding:0;"]);
}, function (props) {
  return props.height === 'auto' && css(["@media screen and (min-width:", "){height:auto;min-height:185px;}@media (-ms-high-contrast:active),(-ms-high-contrast:none){max-height:50vh;}"], props.theme.size.breakpoint['max-width'].sm);
}, function (props) {
  return props.padding && !props.isStatic && css(["@media all and (-ms-high-contrast:none){&::after{content:'';display:block;height:15px;}}@supports (-ms-ime-align:auto){&::after{content:'';display:block;height:15px;}}@supports (-moz-appearance:none){&::after{content:'';display:block;height:15px;}}"]);
});
export var Footer = styled.footer.withConfig({
  displayName: "Drawerstyles__Footer",
  componentId: "sc-7kh0ae-6"
})(["flex:0 0 auto;min-height:45px;border-top:1px solid ", ";width:100%;padding:15px;font-weight:normal;"], function (props) {
  return props.theme.color.monochrome.light;
});
export var Overlay = styled.div.withConfig({
  displayName: "Drawerstyles__Overlay",
  componentId: "sc-7kh0ae-7"
})(["top:0;left:0;width:100%;height:100vh;z-index:80;position:fixed;background-color:rgba(0,0,0,0.5);-webkit-tap-highlight-color:transparent;opacity:0;visibility:hidden;will-change:opacity;", " ", ""], function (props) {
  return props.show && css(["opacity:1;pointer-events:auto;visibility:visible;"]);
}, function (props) {
  return props.isStatic && css(["visibility:hidden;"]);
});